import React from 'react';
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <>
      <div className='container about-us-container'>
        <div className='about-us-container_content'>
          <div className='about-us-container_content_statement'>
            <h1>About Us</h1>
            <p>We are a company specialized in investments in the USA. We cover the entire investment process, defining the exact and most convenient model for our investor partners, generating profitability in dollars.</p>
          </div>
          <ul className='about-us-container_content_attributes'>
            <li><div className='about-us-container_content_attributes_border'></div>Performance</li>
            <li><div className='about-us-container_content_attributes_border'></div>Growth</li>
            <li><div className='about-us-container_content_attributes_border'></div>Profitability</li>
          </ul>
        </div>
        <figure className='about-us-container_content_image'>
          <img src='/AboutUs/welcome2.png' alt='img' />
          <div className='about-us-container_content_image_background'></div>
        </figure>
      </div>
    </>
  );
}

export default AboutUs;